import { Box, Paper } from '@mui/material';
import type { PropsWithChildren } from 'react';
import { cardSx } from './styles';

type BuildCartCardProps = PropsWithChildren<{
  sx?: Record<string, unknown>;
}>;

export const BuildCartCard = ({ children, sx }: BuildCartCardProps) => (
  <Box
    sx={{
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      // 'stretch' would leave a Paper narrower than this wrapper (e.g. a
      // popup skeleton's cardMaxWidth) flush at the left edge instead of
      // centered — 'center' still fills full-width Paper usages identically,
      // since centering a 100%-wide child has no visible effect.
      alignItems: 'center',
      justifyContent: { xs: 'center', md: 'flex-start' },
    }}
  >
    <Paper sx={{ ...cardSx, ...(sx ?? {}) }}>{children}</Paper>
  </Box>
);
